export const JS_TYPES = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    UNDEFINED: "undefined",
    OBJECT: "object",
    FUNCTION: "function",
    BIGINT: "bigint",
    SYMBOL: "symbol"
};